import Vue from "vue";

Vue.filter("displayName", (firstName, lastName) => {
  return `${firstName || ""}${lastName ? " " + lastName : ""}`;
});
